import React from 'react'

const TrendingUp = ({ lightColor, darkColor, circleColor }) => {
  const lightFill = lightColor ? lightColor : '#A0AEC0'
  const darkFill = darkColor ? darkColor : '#4A5568'
  const circleFill = circleColor ? circleColor : '#EDF2F7'

  return (
    <svg width="56" height="56" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <circle cx="28" cy="28" r="28" fill={circleFill} />
        <g fillRule="nonzero">
          <path
            d="M17.471 39.267c-.301.417-.81.613-1.302.502a1.31 1.31 0 0 1-.982-1.019 1.36 1.36 0 0 1 .484-1.35l7.715-8c.5-.508 1.3-.508 1.8 0l4.243 4.387 5.528-5.734a1.252 1.252 0 0 1 1.745.083 1.37 1.37 0 0 1 .055 1.81l-6.428 6.667c-.5.509-1.3.509-1.8 0L24.286 32.2l-6.815 7.067z"
            fill={lightFill}
          />
          <path
            d="M34.044 22.333l-2.957-3.066a1.37 1.37 0 0 1-.268-1.448c.2-.494.664-.817 1.181-.819h7.714c.71 0 1.286.597 1.286 1.333v8a1.334 1.334 0 0 1-.796 1.215 1.252 1.252 0 0 1-1.39-.281l-2.957-3.04-5.528 5.733c-.5.508-1.3.508-1.8 0l-4.243-4.427L17.47 32.6c-.316.378-.81.54-1.28.42a1.311 1.311 0 0 1-.942-.992c-.11-.488.053-.998.422-1.321l7.715-8c.5-.509 1.3-.509 1.8 0l4.243 4.4 4.615-4.774z"
            fill={darkFill}
          />
        </g>
      </g>
    </svg>
  )
}

export default TrendingUp
